module.exports = __webpack_public_path__ + "static/media/vbn-picture-1.e51682e8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Themes/VBN/vbn-picture-1.jpg
// module id = 114
// module chunks = 51